import type { FieldPack } from '../../../core/fields/types';
import { orgchartBaseFieldPack } from './packs/base.pack';
import { orgchartOrganizationFieldPack } from './packs/organization.pack';
import { orgchartRoleFieldPack } from './packs/role.pack';
import { orgchartTalentFieldPack } from './packs/talent.pack';
import { orgchartCompensationFieldPack } from './packs/compensation.pack';
import { orgchartSkillsFieldPack } from './packs/skills.pack';
import { orgchartWorkforceFieldPack } from './packs/workforce.pack';
import { orgchartSuccessionFieldPack } from './packs/succession.pack';
import { orgchartDemographicsFieldPack } from './packs/demographics.pack';
import { orgchartEngagementFieldPack } from './packs/engagement.pack';
import { orgchartDepartmentFieldPack } from './packs/department.pack';
import { orgchartPositionFieldPack } from './packs/position.pack';
import { orgchartTeamFieldPack } from './packs/team.pack';
import { orgchartProjectFieldPack } from './packs/project.pack';
import { orgchartRoleProfileFieldPack } from './packs/role-profile.pack';
import { orgchartSkillsProjectionFieldPack } from './packs/skills-projection.pack';
import { orgchartTalentObservationFieldPack } from './packs/talent-observation.pack';

/** Complete field-pack catalog used by cross-stack policy code. */
export const ORG_CHART_FIELD_PACKS: readonly FieldPack[] = [
  orgchartBaseFieldPack,
  orgchartOrganizationFieldPack,
  orgchartRoleFieldPack,
  orgchartTalentFieldPack,
  orgchartCompensationFieldPack,
  orgchartSkillsFieldPack,
  orgchartWorkforceFieldPack,
  orgchartSuccessionFieldPack,
  orgchartDemographicsFieldPack,
  orgchartEngagementFieldPack,
  orgchartDepartmentFieldPack,
  orgchartPositionFieldPack,
  orgchartTeamFieldPack,
  orgchartProjectFieldPack,
  orgchartRoleProfileFieldPack,
  orgchartSkillsProjectionFieldPack,
  orgchartTalentObservationFieldPack,
];
